export function InviteNeeded(props: { showSignInButton?: boolean; onSignInClick?: () => void }) {
  return (
    <section class="install-safe">
      <div class="install-card">
        <h2 class="install-title">You need an invite</h2>
        <div class="install-body">
          <p class="muted">You need an invite link from a neighbor.</p>
          {props.showSignInButton && (
            <div class="install-actions" style="margin-top:12px;">
              <button class="primary-btn" type="button" onClick={() => props.onSignInClick?.()}>
                Already a member? Sign in
              </button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

